import classNames from 'classnames';

interface TileProps {
  children?: React.ReactNode;
  customClass?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  dataTestId?: string;
}

const Tile = ({ children, customClass, onClick, dataTestId }: TileProps) => {
  const baseClassName = classNames(
    `rounded-lg shadow bg-white p-6 border border-navy-50`,
    customClass
  );

  if (onClick) {
    return (
      <button
        type="button"
        className={baseClassName}
        onClick={onClick}
        data-testid={dataTestId}
      >
        {children}
      </button>
    );
  }

  return (
    <div
      className={baseClassName}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default Tile;
